import './sticky.scss';

interface Props {
	renderStickyElements: (() => JSX.Element)
	top?: string;
}

const Sticky: React.FC<Props> = ({ renderStickyElements, top = '0px', children }) => {
	return (
		<div className="sticky-component-wrapper">
			<div className="sticky-wrap">
				<div className="sticky-container" style={{ top }}>
					<div className="sticky-scroller">
						{renderStickyElements()}
					</div>
				</div>
				{children}
			</div>
		</div>
	);
};

export default Sticky;